// extracted by mini-css-extract-plugin
export default {"textAreaContainer":"InputTextArea_textAreaContainer__M0Cju","errorMessage":"InputTextArea_errorMessage__ySMIN"};